import React from 'react';
import { XCircle, MapPin } from 'lucide-react';
export function VillainSection() {
  return <section className="py-12 md:py-16 bg-warm-200" data-id="element-374">
      <div className="max-w-3xl mx-auto px-4" data-id="element-375">
        <div className="text-center mb-8" data-id="element-376">
          <h2 className="text-2xl md:text-3xl font-bold text-text-dark mb-3" data-id="element-377">
            ¿Por qué nada de lo que probaste funcionó?
          </h2>
        </div>

        <div className="space-y-3 mb-8" data-id="element-378">
          {['Mantén la habitación en silencio absoluto', 'Establece una rutina rígida de horarios', 'El bebé debe dormir solo desde los 3 meses'].map((advice, i) => <div key={i} className="flex items-center gap-3 bg-white p-4 rounded-xl shadow-sm" data-id="element-379">
              <XCircle className="w-5 h-5 text-red-400 shrink-0" data-id="element-380" />
              <p className="text-text-muted line-through text-sm" data-id="element-381">"{advice}"</p>
            </div>)}
        </div>

        <div className="bg-white p-6 rounded-2xl shadow-md mb-8" data-id="element-382">
          <div className="flex items-start gap-3 mb-4" data-id="element-383">
            <MapPin className="w-5 h-5 text-primary-500 shrink-0 mt-0.5" data-id="element-384" />
            <p className="text-text-body" data-id="element-385">
              Esos métodos fueron diseñados para casas suecas y familias que
              viven en silencio. No para apartamentos en Bogotá, Medellín o Cali
              donde el vecino pone música, el perro ladra y la abuela llega sin
              avisar.
            </p>
          </div>
        </div>

        <div className="bg-primary-600 text-white p-6 rounded-2xl text-center" data-id="element-386">
          <p className="text-lg font-semibold" data-id="element-387">
            El método no falló porque vos fallaste.
          </p>
          <p className="text-primary-200 mt-1" data-id="element-388">Falló porque nunca fue tuyo.</p>
        </div>
      </div>
    </section>;
}